import commonMessage from "../../constants/commonMessage";

const { REPLY_MESSAGE_REQUIRED } = commonMessage;

export const support = {
  // Add Faq Schema
  replySupportSchema: {
    message: {
      required: true,
      message: REPLY_MESSAGE_REQUIRED,
      extraMessage: false,
    },
  },
};
